import React from 'react';

const Footer = () => {
  return (
    <footer className="py-6 text-light-grey text-center">
      <p>© 2026 Rorke Melville. All rights reserved.</p>
    </footer>
  );
};

export default Footer;